document.addEventListener("DOMContentLoaded", () => {
    const btn = document.querySelector(".utlab-politika__btn"),
        popup = document.querySelector(".utlab-politika__popup"),
        ok = document.querySelectorAll(
            ".utlab-politika__ok, .utlab-politika__neok"
        );

    btn.addEventListener("click", () => {
        popup.classList.toggle("is-hide");
    });

    ok.forEach(b => {
        b.addEventListener("click", () => {
            popup.classList.add("is-hide");
            document.cookie = "utlabCookieAccept=1; path=/; max-age=2592000";
        });
    });
});
